import React from 'react';

type JsonLdProps = {
    data: Record<string, any> | Array<Record<string, any>>;
};

export default function JsonLd({ data }: JsonLdProps) {
    return (
        <script
            type="application/ld+json"
            dangerouslySetInnerHTML={{ __html: JSON.stringify(data) }}
        />
    );
}
